const priceNotation = (number) => {
    return number.toString().replace(/\d(?=(?:\d{3})+$)/g, '$&.');
}

export default priceNotation;